import React from "react"
import PropTypes from "prop-types"
import viewedImg from "../../images/Notification/icono-aviso-procesado.png"
import notViewedImg from "../../images/Notification/icono-aviso.png"
import HTMLReactParser from "html-react-parser"
import { Modal } from "reactstrap"

const Notification = props => {
  const {
    viewed,
    description,
    link_text,
    link,
    onClick = () => {},
    title,
    popup,
    withModal,
    modalVisible,
  } = props

  const handleClick = e => {
    e.preventDefault()
    onClick(props)
  }

  const renderContent = () => (
    <div
      className={`Notification ${viewed ? "" : "isNew"} ${
        popup && withModal ? "Notification-modal" : ""
      }`}
    >
      <img
        src={viewed ? viewedImg : notViewedImg}
        className="Notification-img"
        alt={`Notification-alert ${title}`}
      />
      <div className="Notification-content">
        <p>{HTMLReactParser(description || "")}</p>
        {link.link_intranet ? (
          <a
            href="#Redirect"
            className="Notification-link"
            onClick={handleClick}
          >
            {link_text}
          </a>
        ) : (
          <a
            href="#Redirect"
            className="Notification-link"
            onClick={handleClick}
          >
            Cerrar aviso
          </a>
        )}
      </div>
    </div>
  )

  if (popup && withModal)
    return (
      <Modal isOpen={modalVisible} centered>
        {renderContent()}
      </Modal>
    )
  return renderContent()
}

Notification.propTypes = {
  viewed: PropTypes.bool,
  description: PropTypes.string,
  link_text: PropTypes.string,
  link: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string,
}

export default Notification
